import React, { useState }  from 'react';
import { useObserver } from "mobx-react";
import { Box, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Dialog, TextField } from '@material-ui/core';
import { stores } from 'mobx-store';
import { RequestStatus } from 'components/GeneralFormView/types';
import Snackbar from '@material-ui/core/Snackbar';
import { UpdatePhoneProps } from './types';
import {
    translate,
  } from '../../helperFunctions/translation';

const UpdateWalletPhoneNumber: React.FC<UpdatePhoneProps> = (props: UpdatePhoneProps) => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [msg, setMsg] = useState("");
    const [open, setOpen] = useState(false);
    const {
        userManagementStore
    } = stores; 
    const {
        handleClose,
        modalOpen,
        userId
    } = props;
    const setInput = (setter: React.Dispatch<React.SetStateAction<string>>) => 
    (event: React.ChangeEvent<HTMLInputElement>) => {
        setter(event.target.value)
    };
    const updatePhoneNumber = async () => {
        try {
            await userManagementStore.updateWalletPhoneNumber(`${userId}`, phoneNumber);
            setPhoneNumber('');
            setMsg(translate('updatedMessage'));
            handleClose();
        } catch (error) {
            setMsg(error || translate("invalidValue"));
        } finally {
            setOpen(true);
        }
    };
    return useObserver(() => (
        <Dialog
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth
        >
        <Card>
            <CardContent>
                {/* <h2>Update wallet phone number</h2> */}
                <h2>{translate("updatePhone")}</h2>
            <TextField
                value={phoneNumber}
                onChange={setInput(setPhoneNumber)}
                autoFocus
                margin="dense"
                id="phoneNumber"
                label={translate("updatePhoneLabel")}
                fullWidth
            />
        </CardContent>
        <CardActions>
            <Button
                variant="contained"
                color="primary"
                disabled={!phoneNumber || !userId}
                onClick={updatePhoneNumber}
            >
                {
                    userManagementStore.state == RequestStatus.LOADING ? 
                    <CircularProgress size="1.2rem" color="inherit" /> : 
                    translate("editButton")
                }
            </Button>
            <Snackbar
                open={open} 
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                message={msg}
            />
        </CardActions>
    </Card>
    </Dialog>
    ));
}
export default UpdateWalletPhoneNumber;